import React, { useState } from "react";
import { Icon, Button, Dialog } from "@blueprintjs/core";
import { useHorizontalScrollNav } from "../../hooks/useHorizontalScrollNav";
import "../../css/performanceAndScroll.css";
import "../goals/GoalSettingsCreateForm.css";
import { FilledButton, OutlinedButton } from "../buttons-20250224T111359Z-001/buttons";
import Flexbox from "flexbox-react";

const StepProcessList = ({
  steps,
  activeStep,
  onStepClick,
  onEdit,
  onDelete,
  onAdd,
  onReorder
}) => {
  const [dragIndex, setDragIndex] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [pendingDrop, setPendingDrop] = useState(null);

  const {
    scrollRef,
    canScrollLeft,
    canScrollRight,
    showArrows,
    scrollByDir
  } = useHorizontalScrollNav({
    arrowsVisibility: "when-overflow",
    layoutDependency: steps,
    activeItemId: activeStep?.id,
    scrollIntoViewAttr: "data-step-id",
    scrollIntoViewEnabled: Boolean(steps?.length),
    minScrollChunk: 200,
    scrollViewportRatio: 0.55
  });

  // const handleDrop = index => {
  //   if (dragIndex === null) return;

  //   const updated = [...steps];
  //   const dragged = updated.splice(dragIndex, 1)[0];
  //   updated.splice(index, 0, dragged);

  //   onReorder(updated, dragged.id, index);

  //   setDragIndex(null);
  // };
  const handleDrop = index => {
    if (dragIndex === null) return;
    if (dragIndex === index) {
      setDragIndex(null);
      return;
    }
    setPendingDrop({
      fromIndex: dragIndex,
      toIndex: index
    });
    setConfirmDialogOpen(true);
  };

  const confirmReorder = () => {
    if (!pendingDrop) return;
    const { fromIndex, toIndex } = pendingDrop;
    const updated = [...steps];
    const dragged = updated.splice(fromIndex, 1)[0];
    updated.splice(toIndex, 0, dragged);
    onReorder(updated, dragged.id, toIndex);
    setDragIndex(null);
    setPendingDrop(null);
    setConfirmDialogOpen(false);
  };

  const cancelReorder = () => {
    setDragIndex(null);
    setPendingDrop(null);
    setConfirmDialogOpen(false);
  };

  const arrowBtnStyle = {
    flexShrink: 0,
    flexGrow: 0,
    // perfectly center vertically
    alignSelf: "center",
    width: 44,
    minWidth: 44,
    height: 44,
    minHeight: 44,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    zIndex: 2,
    boxSizing: "border-box",
    // remove this
    padding: 0,

    // optional spacing
    marginTop: "-35px"
  };

  return (
    <div className="step-process-list-scroll-row">
      {showArrows && (
        <Button
          type="button"
          aria-label="Scroll steps left"
          icon="chevron-left"
          minimal
          small
          disabled={!canScrollLeft}
          onClick={() => scrollByDir(-1)}
          style={arrowBtnStyle}
        />
      )}
      <div
        ref={scrollRef}
        className="step-process-list-scroll-track u-hide-scrollbar-x"
      >
        <div className="stepper stepper--scroll-inner">
          {steps.map((step, index) => {
            const isActive = step.id === activeStep?.id;
            const isHovered = hoveredId === step?.id;

            return (
              <div
                key={step?.id}
                data-step-id={step?.id}
                className="step-block"
                style={{
                  cursor: dragIndex === index ? "grabbing" : "default",
                  transition: "transform 0.2s ease",
                }}
                draggable
                onDragStart={() => {
                  setDragIndex(index);
                }}
                onDragOver={e => e.preventDefault()}
                onDrop={() => handleDrop(index)}
                onMouseEnter={() => setHoveredId(step?.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                <div
                  className={`step-circle ${isActive ? "active" : ""}`}
                  onClick={() => onStepClick(step?.id)}
                  style={{
                    fontSize: "16px",
                    position: "relative",
                    overflow: "hidden",
                    cursor: dragIndex === index ? "grabbing" : "grab",
                  }}
                >
                  {step?.id ? index + 1 : ""}
                  <div
                    className="hover-ring"
                    style={{
                      fontSize: "16px",
                      position: "relative",
                      overflow: "hidden",
                      cursor: dragIndex === index ? "grabbing" : "grab",
                      transition: "all 0.2s ease",
                      transform: isHovered ? "scale(1.06)" : "scale(1)",
                      boxShadow: isHovered
                        ? "0 6px 18px rgba(72, 126, 255, 0.18)"
                        : "none",
                    }}
                  />

                  {isHovered && (
                    <div
                      className="hover-actions"
                      style={{
                        position: "absolute",
                        top: "-25px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        background: "#fff",
                        padding: "6px 10px",
                        borderRadius: "20px",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                        animation: "fadeUp 0.2s ease",
                        zIndex: 200,
                        overflow: "visible",
                        cursor: "pointer"
                      }}
                    >
                      <Icon
                        icon="edit"
                        size={14}
                        style={{ color: "#5f6b7c" }}
                        onClick={e => {
                          e.stopPropagation();
                          onEdit(step);
                        }}
                      />
                      {!step.predefined && (
                        <Icon
                          icon="trash"
                          size={14}
                          style={{ color: "#5f6b7c" }}
                          onClick={e => {
                            e.stopPropagation();
                            onDelete(step.id);
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>

                <div onClick={() => onStepClick(step?.id)} className={`step-label ${isActive ? "active" : ""}`}>
                  {step.step_name}
                </div>
                <div className="step-arrow">→</div>
              </div>
            );
          })}

          <div
            className="step-block add"
            draggable={false}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              onAdd();
            }}
          >
            <div className="step-circle dashed">+</div>
            <div className="step-label">Add</div>
          </div>
        </div>
      </div>
      {showArrows && (
        <Button
          type="button"
          aria-label="Scroll steps right"
          icon="chevron-right"
          minimal
          small
          disabled={!canScrollRight}
          onClick={() => scrollByDir(1)}
          style={arrowBtnStyle}
        />
      )}
      <Dialog
        isOpen={confirmDialogOpen}
        onClose={cancelReorder}
        title="Confirm Step Reorder"
        portalContainer={document.body}
      >
        <div style={{ padding: "25px" }} >
          <p style={{ marginBottom: "20px", lineHeight: "1.6" }} >
            Are you sure you want to reorder this step ?
            <br />
            <br />
            Reordering steps after the goal cycle has been published may impact
            the review flow, submission sequence, and existing participant data.
            Please make sure this change will not affect users who have already
            started or completed the review process.
          </p>

          <Flexbox gap="10px" flexDirection="row" justifyContent="flex-start" alignItems="center" className="mt-20" >
            <FilledButton text="Confirm" onClick={confirmReorder} style={{ marginRight: "10px" }} />
            <OutlinedButton text="Cancel" onClick={cancelReorder} />
          </Flexbox>
        </div>
      </Dialog>
    </div>
  );
};

export default StepProcessList;
